export enum RegionType {
  inventory = 'inventory',
  geopos = 'geopos'
}
